<template>
  <div class="container" style="padding-top: 10px">

    <a href="/#/dashboard/perfil" class="sideBtn bg_5 c_blanco">
      <!--Icono-->
      <span class="iconify" data-icon="clarity:user-solid"></span>
      <!--Text-->
      <p class="c_blanco">Mi Cuenta</p>
    </a>

    
    <a href="/#/dashboard/ofertaDisp" class="sideBtn bg_4 c_blanco">
      <span class="iconify" data-icon="ion:book-sharp"></span>
      <p class="c_blanco">Ofertas Disponibles</p>
    </a>

 

    <a href="/#/dashboard/miFormacion" class="sideBtn bg_1 c_blanco">
      <!--Icono-->
      <span class="iconify" data-icon="fa:graduation-cap"></span>
      <!--Text-->
      <p class="c_blanco">Mi formación</p>
    </a>


    <!--
    <b-list-group>
      <b-list-group-item variant="primary">Menu Usuario</b-list-group-item>
      <b-list-group-item to="/dashboard/perfil" active-class="active"
        >Mi Cuenta</b-list-group-item
      >
      <b-list-group-item to="/dashboard/ofertaDisp" active-class="active"
        >Oferta Disponible</b-list-group-item
      >
      <b-list-group-item to="/dashboard/miFormacion" active-class="active"
        >Mi Formación</b-list-group-item
      >
  
    
    </b-list-group>

  -->
    <!--
    <a v-if="perfil == 'ADMIN'" href="/#/dashboard/adminInstancias" class="sideBtn bg_6 c_blanco">
  
      <span class="iconify" data-icon="fa6-solid:school"></span>
      <p class="c_blanco">Instancias Formadoras</p>
    </a>
  -->
    <!--
    <a v-if="perfil == 'ADMIN'" href="/#/dashboard/adminOfertas" class="sideBtn bg_4 c_blanco">
      
      <span class="iconify" data-icon="lets-icons:book-fill"></span>
  
      <p class="c_blanco">Ofertas de Formación</p>
    </a>
    -->

    <!--
    <a v-if="perfil == 'ADMIN'" href="/#/dashboard/adminGrupos" class="sideBtn bg_5 c_blanco">
      <span class="iconify" data-icon="mingcute:group-3-fill"></span>
      <p class="c_blanco">Grupos</p>
    </a>
  -->

    <a class="sideBtn bg_2 c_blanco" @click="CerrarSesion()">
      <!--Icono-->
      <span class="iconify" data-icon="streamline:logout-1-solid"></span>
      <!--Text-->
      <p class="c_blanco">Cerrar Sesión</p>
    </a>
    <!--


    <b-list-group v-if="perfil == 'ADMIN'">
      <b-list-group-item variant="primary">Administración</b-list-group-item>
      <b-list-group-item to="/dashboard/adminInstancias" active-class="active"
        >Instancias Formadoras</b-list-group-item
      >
      <b-list-group-item to="/dashboard/adminOfertas" active-class="active"
        >Ofertas de Formación</b-list-group-item
      >
      <b-list-group-item to="/dashboard/adminGrupos" active-class="active"
        >Grupos</b-list-group-item
      >
        b-list-group-item to="/dashboard/adminCargaMasiva" active-class="active"
        >Movimientos Masivos</b-list-group-item
    -->
    <!--b-list-group-item to="/dashboard/adminUsuarios" active-class="active"
        >Usuarios</b-list-group-item
    -->
    <!--b-list-group-item to="/dashboard/adminRegistros" active-class="active"
        >Registros</b-list-group-item
    -->
    <!--b-list-group-item to="/dashboard/adminReportes" active-class="active"
        >Reportes</b-list-group-item

 
    </b-list-group>
  -->
  </div>
</template>

<script>
export default {
  name: "SidebarComponent",
  data() {
    return {
      perfil: sessionStorage.getItem("perfil")
    }
  },

  mounted() {
    return { perfil: sessionStorage.getItem("perfil") }
  },
  methods: {
    CerrarSesion() {
      const accessToken = sessionStorage.getItem("token");
      fetch(`https://accounts.google.com/o/oauth2/revoke?token=${accessToken}`, {
        method: "POST",
        mode: "no-cors"
      });


      // Clear all local and session storage
      localStorage.clear();
      sessionStorage.clear();

      // Delete all non-HttpOnly cookies accessible to JS
      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
      });

      this.$router.push('/')

    }
  },
};
</script>
